module.exports = __webpack_public_path__ + "static/media/tecnico.86cfa116.svg";